import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "src/components/ui/Button";
import { applicationStore } from "src/store/ApplicationStore";
import FailIconDisplay from "src/components/ui/FailIconDisplay";
import { useTranslation } from "react-i18next";

const NotFound = () => {

    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <div className="custom-container">
            <div className="flex justify-between flex-col items-center h-full pt-[10px]">
                <div className="pt-8">
                    <div>
                        <div className="text-h5 font-bold mb-2 text-flow-heading">{t('errors.notFoundTitle')}</div>
                        {/* <div className="text-body text-Gray900">
                            Please check the correctness of the link sent to you
                        </div> */}
                    </div>
                    <div className="w-[313px] h-[313px]">
                        <div className="mt-4 relative">
                            <FailIconDisplay />
                        </div>
                    </div>
                    <div className="mt-2 px-3 py-3 text-center z-10">
                        <ul className="list-disc list-inside text-Gray900 mt-3">
                            <li>{t('errors.ensureLinkCorrect')}</li>
                            <li>{t('errors.youCanAccessFlow')}</li>
                        </ul>
                    </div>
                    <div>
                        <Button onClick={() => { navigate(`/?aid=${applicationStore.aidCode}`, { replace: true }) }} className="mt-4" variant="primaryWithoutIcon">{t('actions.startAgain')}</Button>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default NotFound
